// What a matrix costs before any of it is spent (plan §3.5): the numbers the wizard shows next
// to the "Одобри" button, so quota is a decision rather than a surprise.
import { PAGES_PER_QUERY } from './templates.js';
export function estimateMatrix(candidates, capPerRun) {
    const queries = candidates.length;
    const cap = Math.max(1, capPerRun);
    const perNight = candidates.reduce((sum, c) => sum + 1 / Math.max(1, c.cooldownDays), 0);
    return {
        queries,
        maxCalls: queries * PAGES_PER_QUERY,
        drainNights: Math.ceil(queries / cap),
        steadyQueriesPerNight: Math.round(perNight * 10) / 10,
        steadyCallsPerNight: Math.round(perNight * PAGES_PER_QUERY),
    };
}
//# sourceMappingURL=estimate.js.map